import { useQuery } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
// import { useGetDates } from 'src/hooks/date/use-get-dates'
// import { giftSentRankingLiveService } from 'src/service/gift/gift-sent-ranking/live'
import { useShallow } from 'zustand/react/shallow'

import { giftSentRankingLiveService } from '../../../../services/lives/lives'
import { useGlobalStore } from '../../../../store/global-store'
import type { TypeLive } from '../../../../types/lives/live'
import { useGetDates } from '../../../date/use-get-dates'

export const MULTI_LIVE_TROPHY_QUERY_KEY = 'getMultiLiveTrophySumAll'

export const useGetMultiLiveTrophySumAll = (
  typeLive: TypeLive,
  enabled = true,
) => {
  const liveUserId = useGlobalStore(useShallow((state) => state.liveUserId))

  const { day } = useGetDates()

  const [params, setParams] = useState({
    initialDate: day,
    finalDate: day,
    typeLive,
  })

  const { data, isLoading, refetch } = useQuery({
    queryKey: [MULTI_LIVE_TROPHY_QUERY_KEY, params, { liveUserId, typeLive }],
    staleTime: 0,
    enabled,
    queryFn: () =>
      giftSentRankingLiveService.getMultiLiveTrophy({
        ...params,
        typeLive,
        userReceivedId: liveUserId as number,
      }),
  })

  const get = useCallback(
    (variables: typeof params) => {
      setParams(variables)
    },
    [setParams],
  )

  return {
    liveTrophy: data?.data,
    isLoading,
    refetch,
    get,
  }
}
